function Input({ label, id, error, className = "", labelClassName = "", ...props }) {
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={id}
          className={`mb-1.5 block text-xs font-semibold uppercase tracking-[0.08em] text-app-ink-muted ${labelClassName}`}
        >
          {label}
        </label>
      )}
      <input
        id={id}
        aria-invalid={error ? "true" : "false"}
        className={`w-full rounded-xl border bg-white px-3 py-2.5 text-sm text-app-ink shadow-soft outline-none transition ${
          error
            ? "border-app-danger focus:border-app-danger focus:ring-4 focus:ring-red-200/70"
            : "border-app-line focus:border-app-brand focus:ring-4 focus:ring-app-brand/15"
        } ${className}`}
        {...props}
      />
      {error && <p className="mt-1.5 text-xs text-app-danger">{error}</p>}
    </div>
  );
}

export default Input;
